module.exports = __webpack_public_path__ + "img/proveedores.0a96211a.png";